import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * RootRedirect — 루트 경로(`/`) 접근 시 인증 상태에 따라 리다이렉트하는 컴포넌트
 *
 * - isLoading 중에는 로딩 UI를 표시한다.
 * - 인증된 사용자 → /dashboard
 * - 미인증 사용자 → /login
 *
 * @returns {React.ReactElement}
 *
 * Validates: Requirements 1.2
 */
const RootRedirect = () => {
  const { isLoggedIn, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="loading">
        <div className="loading-spinner" />
        <span>로딩 중...</span>
      </div>
    );
  }

  if (isLoggedIn) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Navigate to="/login" replace />;
};

export default RootRedirect;
